import { ToCanvasFn } from './VideoPlayer';

export interface CurvePoint {
    x: number;
    y: number;
}

export interface CurvePoints {
    h_lines: CurvePoint[][];
    v_lines: CurvePoint[][];
}

export const CURVE_COLOR = 'rgba(50, 180, 255, 0.7)';
export const INPUT_POINT_COLOR = 'rgba(255, 60, 60, 0.95)';

const drawPolyline = (ctx: CanvasRenderingContext2D, toCanvas: ToCanvasFn, points: CurvePoint[]) => {
    if (points.length < 2) return;
    ctx.beginPath();
    const [sx, sy] = toCanvas(points[0].x, points[0].y);
    ctx.moveTo(sx, sy);
    for (let i = 1; i < points.length; i++) {
        const [px, py] = toCanvas(points[i].x, points[i].y);
        ctx.lineTo(px, py);
    }
    ctx.strokeStyle = CURVE_COLOR;
    ctx.lineWidth = 2;
    ctx.stroke();
};

export const drawCurveOverlay = (
    ctx: CanvasRenderingContext2D,
    toCanvas: ToCanvasFn,
    curvePoints: CurvePoints | null,
    inputPoints?: CurvePoint[] | null,
) => {
    if (curvePoints) {
        curvePoints.h_lines.forEach(line => drawPolyline(ctx, toCanvas, line));
        curvePoints.v_lines.forEach(line => drawPolyline(ctx, toCanvas, line));
    }
    if (inputPoints) {
        inputPoints.forEach(p => {
            const [cx, cy] = toCanvas(p.x, p.y);
            ctx.beginPath();
            ctx.arc(cx, cy, 6, 0, Math.PI * 2);
            ctx.fillStyle = INPUT_POINT_COLOR;
            ctx.fill();
            ctx.lineWidth = 1.5;
            ctx.strokeStyle = 'white';
            ctx.stroke();
        });
    }
};
